import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Customer} from '../../model/Entities/Customer';
import {Product} from '../../model/Entities/Product';
import {FormControl, Validators} from '@angular/forms';
import {numberValidator} from '../../validators/number.validator';
import {intValidator} from '../../validators/int.validator';

@Component({
    selector: 'inventory-check-dialog',
    templateUrl: './inventory-check.dialog.component.html',
    styleUrls: []
})
export class InventoryCheckDialogComponent {

    date = new Date();

    // dateFC = new FormControl('', [
    //     Validators.required,
    // ]);

    constructor(public dialog: MatDialogRef<InventoryCheckDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    checkValidity(): boolean {
        return true;
        // return this.dateFC.valid;
    }
}



// WEBPACK FOOTER //
// /app/src/ProductsModule/InventoryCheckDialogComponent/inventory-check.dialog.component.ts